import type { TRPC_ERROR_CODE_KEY } from '@trpc/server/rpc'
import { TRPC_ERROR_CODES_BY_KEY } from '@trpc/server/rpc'

/**
 * Reads the tRPC error code off a thrown mutation error. The client wraps
 * server errors as `TRPCClientError` (code under `data`), while some paths
 * surface the raw server shape (code under `shape.data`); accept both so a
 * CONFLICT is never missed and silently reported as a generic failure.
 *
 * Narrowed to tRPC's own code union rather than `string` so that a mistyped
 * literal at a call site (`'CONFLCT'`) fails to compile instead of comparing
 * false forever and silently degrading into the generic branch.
 */
export function errorCode(error: unknown): TRPC_ERROR_CODE_KEY | null {
  if (!error || typeof error !== 'object') return null
  const candidate = error as {
    data?: { code?: unknown }
    shape?: { data?: { code?: unknown } }
  }
  const code = candidate.data?.code ?? candidate.shape?.data?.code
  return typeof code === 'string' &&
    Object.hasOwn(TRPC_ERROR_CODES_BY_KEY, code)
    ? (code as TRPC_ERROR_CODE_KEY)
    : null
}
